// extracted by mini-css-extract-plugin
export var container = "Institution-module--container--39f52";
export var eyebrow = "Institution-module--eyebrow--c7d71";
export var title = "Institution-module--title--a9899";